import { CANDY_SWORD } from './../classes/Spells'
import { CHARACTER_TYPES, CHARACTER_VARIANTS } from './../../../f.assets/Characters/scripts/constants'
import { Vector2 } from 'three'
import { useSceneStore } from '../../../a.scenes/GameScene/store'
import { useScenesStore } from '../../../b.providers/ScenesProvider/store'
import { CharacterBaseState } from '../../../c.managers/CharactersManager/types'
import { BATTLE_STATES, COMMANDERS } from '../../../c.managers/LevelManager/store.d'
import { Tile } from '../../../c.managers/TerrainManager/store.d'
import { Animations } from '../../../d.controllers/AnimationController'
import { Characters } from '../../../d.controllers/CharactersController'
import { Terrain } from '../../../d.controllers/TerrainController'
import {
  ActionAttack,
  ActionAttackTo,
  ActionAwait,
  ActionHitReceived,
  ActionLoot,
  ActionMove,
  CharacterAction,
} from '../../../f.assets/Characters/scripts/classes/CharacterActions'
import { CHARACTER_ACTION, CHARACTER_STATES } from '../../../f.assets/Characters/scripts/constants'
import { ATTACK_TYPES, getRangeByAttack } from '../../Grid/scripts/helpers/getRangeByAttack'
import { getShortestPathToDestinations } from '../../Grid/scripts/helpers/getShortestPathToTresure'
import getTreasureAccessPositions from '../../Grid/scripts/helpers/getTreasureAccessPositions'
import Minion from '../classes/Minion'
import Treasure from '../classes/Treasure'
import getGameElementByUUID from './getGameElementByUUID'
import { GAME_OBJECTS } from '../classes/types'
import Candy from '../classes/Candy'
import { Battle } from '../../../d.controllers/BattleController'
import { Audio } from '../../../d.controllers/AudioController'
import getEnemyTreasure from '../../Grid/scripts/helpers/getEnemyTreasure'

export default class MinionActionPerformer {
  minion: Minion
  constructor(minion: Minion) {
    this.minion = minion
  }

  async performAction(currentAction: CharacterAction) {
    const obj = this.minion.obj

    // GLOBAL STATE
    const charStates = useSceneStore.getState().characters.data.characterStates
    const updateCharacterState = useSceneStore.getState().characters.updateCharacterState
    const minionSstate = charStates[obj.uuid] as CharacterBaseState

    const grid = useScenesStore.getState().getGameElement('gridElement')?.userData.grid

    // clear target id if this action is not a move
    if (currentAction.type !== CHARACTER_ACTION.MOVE && this.minion.targetUUID) {
      this.minion.targetUUID = undefined
    }

    switch (currentAction.type) {
      case CHARACTER_ACTION.DIE:
        this.minion.clearActions()
        this.minion.invalidate = true

        Terrain.removeElementFromCoords(this.minion.coords)
        await Animations.defeat(this.minion.obj)
        await Animations.dieIntoTheGround(this.minion.obj)
        
        Characters.updateState(this.minion.uuid, {
          state: CHARACTER_STATES.INACTIVE,
          coords: this.minion.plot,
          hp: this.minion.hp_max,
        })
        this.minion.chasingCandy = false
        const teleportToPlot = () => {
          // teleport
          const plotPosition = Terrain.coordsToPosition(this.minion.plot)
          this.minion.obj.position.x = plotPosition.x
          this.minion.obj.position.z = plotPosition.z
          //--
          this.minion.invalidate = false
          this.minion.isDead = false
          // console.log('READY TO RESPAWN')
        }

        const tryTeleportToPlot = () => {
          if(useSceneStore.getState().levels.data.battleState === BATTLE_STATES.ONGOING) {

            const movedToPLot = Terrain.moveObject(this.minion.obj, this.minion.plot)
            
            if(movedToPLot) {
              teleportToPlot()
            } else {
              setTimeout(tryTeleportToPlot, 500)
            }
          }
        }

        tryTeleportToPlot()

        break
      case CHARACTER_ACTION.ATTACK:
        {
          const action = currentAction as ActionAttack
          const prey = getGameElementByUUID(action.targetUUID) as Minion
          prey.receiveHit(new ActionHitReceived({ dealer: this.minion, power: action.power }))
          Audio.playPunch()

          Animations.attack(this.minion.obj, prey.obj)

          const preyWillDie = prey.hp <= 0
          if (!preyWillDie) {
            // attack again
            this.enqueueAttackAction(action.targetUUID, action.power)
            // this.minion.setActions([new ActionAttack(action.targetUUID, action.power)])
            // this.minion.actions = [new ActionAttack(action.targetUUID, action.power)]
          } else {
            // cellebrate?
          }
        }
        break
      case CHARACTER_ACTION.ATTACKTO:
        const action = currentAction as ActionAttackTo
        this.minion.targetUUID = action.targetUUID
        const targetCoords = getGameElementByUUID(this.minion.targetUUID).coords

        await this.resolveAttackBehavior(targetCoords, currentAction)
        Animations.idle(this.minion.obj)

        break
      case CHARACTER_ACTION.GOTO:
        const pathToDestination = await getShortestPathToDestinations(this.minion.coords, [currentAction.coords])
        if (pathToDestination?.length) {
          // discard first position since is the current minion position
          pathToDestination?.shift()
          this.minion.setActions([
            ...pathToDestination!.map(
              (c, idx) =>
                new ActionMove({ coords: new Vector2(c.x, c.y), mandatory: currentAction.mandatory && idx < 4 }),
            ),
            currentAction,
          ])
          // this.minion.actions = [
          //   ...pathToDestination!.map(c => new ActionMove({ coords: new Vector2(c.x, c.y) })),
          //   currentAction,
          // ]
        } else {
          this.minion.loot()
        }
        Animations.idle(this.minion.obj)
        break
      case CHARACTER_ACTION.MOVE:
        if (this.minion.targetUUID) {
          // is hunting
          const prey = getGameElementByUUID(this.minion.targetUUID) as Minion
          const targetCoords = prey.coords
          // checks if pray is close enough to call out freeze!
          const distanceToPrey = targetCoords.manhattanDistanceTo(this.minion.coords)

          if (distanceToPrey < 3) {
            // FREEZE
            // preppends 3 await actions
            prey.preppendActions([new ActionAwait(), new ActionAwait(), new ActionAwait()])
            // prey.actions = [new ActionAwait(), new ActionAwait(), new ActionAwait(), ...prey.actions]
          }

          // check if prey has moved
          const attackActionIdx = this.minion.actions.findIndex(a => a.type === CHARACTER_ACTION.ATTACKTO)
          const attackToAction = this.minion.actions[attackActionIdx]
          const preyHasMoved = attackToAction && !targetCoords.equals(attackToAction.coords)
          // const lastPathCoords = this.minion.actions[this.minion.actions.length - 1].coords
          if (preyHasMoved) {
            attackToAction.coords = prey.coords
            // PREY MOVED
            // console.log('prey has moved, recalculate path')

            // recalculates path and takes first move of new path as current action.
            // fast action instead of waiting next tick
            await this.resolveAttackBehavior(targetCoords, currentAction)
            currentAction = this.minion.getNextAction()
          } else {
            // PREY STILL
            // console.log('prey still')
          }
        }
        const distanceToTarget = currentAction.coords.manhattanDistanceTo(this.minion.coords)

        if (distanceToTarget === 1) {
          // destination is 1 tile away
          const tile = grid[currentAction.coords.x][currentAction.coords.y] as Tile

          if (tile.isEmpty()) {
            Terrain.moveObject(this.minion.obj, currentAction.coords)
            await Animations.simpleTravel(this.minion.obj, minionSstate.coords, currentAction.coords)
          } else if (Terrain.getElementAt(currentAction.coords)?.types.includes(GAME_OBJECTS.CANDY)) {
            // is candy
            const candy = Terrain.getElementAt(currentAction.coords) as Candy
            this.minion.chasingCandy = false
            candy.pickUp(this.minion)
            await Animations.pickUpFrom(this.minion.obj, candy.coords)
            this.minion.removeFollowingMoveActions()
          } else {
            Animations.idle(this.minion.obj)
            this.minion.removeFollowingMoveActions()
          }
        }

        break
      case CHARACTER_ACTION.LOOT:
        const pathToTresure = await getShortestPathToDestinations(
          minionSstate.coords,
          getTreasureAccessPositions(minionSstate.owner!),
        )

        if (pathToTresure === null) {
          // can't find the path to target
          if(!this.minion.isInvalidated) {
            updateCharacterState(obj.uuid, {
              state: CHARACTER_STATES.IDLE,
            })
          }
          this.minion.clearActions()
        } else if (pathToTresure.length === 0) {
          // I'm in loot position
          if (this.minion.owner === COMMANDERS.PLAYER) {
            // console.log('LOOT!!!!')
          }

          // updates only once the minion state
          if (this.minion.state !== CHARACTER_STATES.LOOTING && !this.minion.isInvalidated) {
            Animations.loot(this.minion.obj, currentAction.coords)
            updateCharacterState(obj.uuid, {
              state: CHARACTER_STATES.LOOTING,
            })
          }

          // updates enemy treasure reserves
          const enemyTreasure = getEnemyTreasure(this.minion.owner!)

          if (enemyTreasure) {
            enemyTreasure.getsLooted(5)

            if (enemyTreasure.reserves > 0) {
              this.minion.loot()
              // this.minion.setActions([new ActionLoot()])
            }
          }

          // updates commander mana
          Battle.updateMana(this.minion.owner!, 1)
        } else {
          // there's road to walk
          if(!this.minion.isInvalidated) {
            updateCharacterState(obj.uuid, {
              state: CHARACTER_STATES.ACTING,
            })
          }

          // discard first position since is the current minion position
          pathToTresure?.shift()
          this.minion.preppendActions([
            ...pathToTresure!.map(
              (c, idx) =>
                new ActionMove({ coords: new Vector2(c.x, c.y), mandatory: currentAction.mandatory && idx < 4 }),
            ),
            currentAction,
          ])
          // this.minion.actions = [
          //   ...pathToTresure!.map(c => new ActionMove({ coords: new Vector2(c.x, c.y) })),
          //   currentAction,
          //   ...(this.minion.actions || []),
          // ]
        }
        break
      case CHARACTER_ACTION.RESPAWN:
        // console.log('RESPAWN');
        
        await Animations.riseFromTheGround(obj)
        updateCharacterState(obj.uuid, {
          state: CHARACTER_STATES.IDLE,
        })
        break
      case CHARACTER_ACTION.AWAIT:
        Animations.idle(this.minion.obj)
        break
      default:
        return false
    }
  }

  // gets a target attack coords, calcs the path, solve if it's unreachable, close enough or must move.
  async resolveAttackBehavior(targetCoords: Vector2, currentAction: CharacterAction) {
    const pathToTargetAttack = await getShortestPathToDestinations(
      this.minion.coords,
      getRangeByAttack(ATTACK_TYPES.PUNCH, targetCoords),
    )
    const distanceToTarget = targetCoords.manhattanDistanceTo(this.minion.coords)

    if (!pathToTargetAttack?.length && distanceToTarget > 1) {
      // UNREACHABLE TARGET
      // console.log('unreachable target')
    } else {
      pathToTargetAttack?.shift()
      if (pathToTargetAttack?.length === 0 && distanceToTarget === 1 && this.minion.targetUUID) {
        // at range and chasing, attack
        // HIT
        // console.log('HIT!')

        const hitArgument = { dealer: this, power: 3 }
        this.minion.clearActions()

        // if Diablo, deathtouch
        const finalPower =
          this.minion.mutation === CHARACTER_VARIANTS.DIABLO ? Number.MAX_SAFE_INTEGER : hitArgument.power
        this.minion.instantAction(new ActionAttack(this.minion.targetUUID, finalPower))

        this.minion.targetUUID = undefined
      } else {
        currentAction.coords = targetCoords
        if (currentAction.type !== CHARACTER_ACTION.MOVE) {
          this.minion.actions.push(currentAction)
        }
        this.minion.removeFollowingMoveActions()
        // preppend new path
        this.minion.preppendActions([
          ...pathToTargetAttack!.map(
            (c, idx) =>
              new ActionMove({ coords: new Vector2(c.x, c.y), mandatory: currentAction.mandatory && idx < 4 }),
          ),
        ])
        // this.minion.actions = [
        //   ...pathToTargetAttack!.map(c => new ActionMove({ coords: new Vector2(c.x, c.y) })),
        //   ...this.minion.actions,
        // ]
      }
    }
  }

  enqueueAttackAction(uuid: string, power: number) {
    // if Diablo, deathtouch
    const finalPower =
      this.minion.mutation === CHARACTER_VARIANTS.DIABLO
        ? Number.MAX_SAFE_INTEGER
        : this.minion.mutation === CHARACTER_VARIANTS.CANDY_ARMORED
        ? 6 // capricious value for a hit with candy sword
        : power
    this.minion.setActions([new ActionAttack(uuid, finalPower)])
  }
}
